import { render } from "./CartHeaderTag.vue?vue&type=template&id=7c90a59e"
import script from "./CartHeaderTag.vue?vue&type=script&lang=js"
export * from "./CartHeaderTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__